import {  Inject } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';

import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { selectionfilter, fileObj } from '../../shared/misc-classes';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
// import {NotificationsService} from 'angular2-notifications';

//import { LogisticIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ActualDateChange, PlannedDateToken, RequestDateToken, ValidationItem, ValidationSummary, ActualDateToken, PartialDelivery, GenFileUploads } from '../../../shared/misc-classes';
import { FileElement, MarketingIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType,SubSalesOrder,SalesOrder,Equipment, PartialDelivery, configDefs, BreakerPS } from '../../shared/misc-classes';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { from, Subscription, of } from 'rxjs';
import { SubSalesorderComponent } from '../../projects/edit-sales-order/sub-salesorder/sub-salesorder.component';
import { UntypedFormControl as FormControl } from '@angular/forms';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';
import { HttpClient, HttpErrorResponse, HttpEventType, HttpRequest } from '@angular/common/http';
import { catchError, last, map, tap } from 'rxjs/operators';
import {  trigger,  state,  style,  animate,  transition} from '@angular/animations';


@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.html',
  styleUrls: ['./file-upload-dialog.css'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [
        animate(300, style({ opacity: 0 }))
      ])
    ])
  ]
})


export class FileUploadDialog  {
  @Input() soObj: SubSalesOrder;
  
 
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  //@Input() lstItems:Array<selectionfilter>;
  //@Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  // disableForm: boolean = true;
  // public _SSOStatus = SSOStatus;
  // @Input() disable: boolean;
  @Input() text = 'Add Mail Attachment';
  @Input() param = 'file';
  // @Input() target = '/fileattach';
  @Input() target = '/fileattach';
  /** File extension that accepted, same as 'accept' of <input type="file" />. 
      By the default, it's set to 'image/*'. */
  @Input() accept = 'image/*';
  @Output() complete = new EventEmitter<string>();

  public files: Array<FileUploadModel> = [];

  displayedColumns = ['sno', 'filename', 'username', 'filetype', 'fileref','DateTime'];
  masterclass:boolean;
  textVar =[];
  fname = [];
  fref =[];
  checks:boolean;
  selectAll:boolean;
  subSoList: Array<SubSalesOrder>;
  subSoNo:string;
  userLogged_temp:string;
  isUserImpEnabled:boolean = false;
  
  // specialPoint:SpecialPoint;
  // refElement:SpecialPoint;

 

  // displayedColumns = ['sno', 'filename', 'filetype', 'fileref'];
  // dataSource : FileElement[] = [
  //   {sno: 1, filename: 'My Test File', filetype: 'excel', fileref: '001'}
  // ];;

  filesList:Array<FileElement> = [];
  refElementList:Array<FileElement> = [];
  dataSource : FileElement[] = [
    // {sno: 1, filename: 'My Test File', filetype: 'excel', fileref: '001'}
  ];;
  
  downloadFileIndex:number = 0;
  totalDownloadCount:number = 0;
  isDownloadMode:boolean = false;
  isDownloadComplete:boolean = false;
  zip = new JSZip();
  
  userLogged:string;
  // _notify : NotificationsService;
  readaccess : boolean
  sno:number = 1;
  mailBody: string;
  mailID: string;
  mailCC: string[];
  mailSub:string;
  selectedFileList:string[];
  selectedCCList:string[] = [];
  toMailModel='';
  ccMailModel= '';
  subModel='';
  bodyModel='';
  fileToUpload: File = null;
  imagelist:string []= [];
  base64textString: string;
  // baseFile_temp:string[];
  // baseFile:string;
  // body:any;
  body:string[] =[];
  imgList:any[] =[];
  fileImg:File[]=[];
  mailList:any =[];
  
  constructor(private _dataService:DataService,
    public dialogRef: MatDialogRef<FileUploadDialog>,
    private _snackBar: MatSnackBar,
    private _http:HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      //this.masterclass = false;
      let _subSo: SubSalesOrder;
      this.checks = false;      
      this.filesList = this.data.files; 
      /// THE JSON HAS STORED isSelected VALUES ARE TRUE FOR SOME DATA
      this.filesList.forEach((_tmpFile:FileElement) => {
        _tmpFile.isSelected = false;
      });
      ///
      this.readaccess = this.data.readAccess;
      if(this.filesList == null) this.filesList = [];
      this.refElementList = [];
      this.filesList.forEach((_tmpFile:FileElement) => {
      this.refElementList.push(_tmpFile.cloneSelf());
      })
      // this.refElementList = this.filesList.cloneSelf();
    }


    saveSso(): void{
      this.filesList = this.refElementList;
      this.dialogRef.close();
    }
    // saveSso(_submitToNextSection: boolean, ssoSubmitTo: SSOStatus = SSOStatus.Not_Started) {
    //   if (this.updateSubSalesOrder) {
    //     this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders,
    //       (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data),
    //       null,
    //       ssoSubmitTo
    //     ));
    //   }
    // }
  onNoClick(): void {
    this.filesList = this.refElementList;
    this.dialogRef.close();
  }


  SelectAll(e){
    this.textVar = [];
      if(e.target.checked == true){
        for(var i =0; i<this.filesList.length;i++){
          this.textVar.push(this.filesList[i])
        }
        if(this.filesList){
          this.filesList.forEach((_tmpItem:FileElement) => {
            _tmpItem.isSelected = true;
          });
          let fl = document.getElementsByClassName('checkFile');          
          for(var i=0; i < fl.length; i++) {
            let atr =<HTMLInputElement>fl[i];
            if(atr.type == 'checkbox') {
              atr.checked = e.target.checked;
            }
          }

        }
        //console.log(this.filesList)
        this.checks = true;
        this.selectAll = true;
      }
      else{
        this.textVar = [];
        if(this.filesList){
          this.filesList.forEach((_tmpItem:FileElement) => {
            _tmpItem.isSelected = false;
          });
          let fl = document.getElementsByClassName('checkFile');
          for(var i=0; i < fl.length; i++) {
            let atr =<HTMLInputElement>fl[i];
            if(atr.type == 'checkbox') {
              atr.checked = e.target.checked;
            }
          }
        }
        // this.checks = false;
        this.selectAll = false;
      }
    }
  

  itemClicked(_tmpItem:FileElement,_index){
    _tmpItem.isSelected = !_tmpItem.isSelected;

    let flag:boolean = true;
    if(_tmpItem.isSelected){
      if(this.textVar.length > 0){
        this.textVar.forEach((file) => {
          if(file.filename == _tmpItem.filename){
            flag = false;
          }
        })
      }
      if(flag){
        this.textVar.push(_tmpItem);
      }
      
    }
    else{
      this.textVar.splice(_index,1);
    }
    let fl = document.getElementsByClassName('checkFile');
    let _tmpFlag = [];
    for(var i=0; i < fl.length; i++) {
      let atr =<HTMLInputElement>fl[i];
      if(atr.type == 'checkbox') {
          _tmpFlag.push(atr.checked);
      }
    }
    if(_tmpFlag.includes(false)){
      this.selectAll = false;
    }
    else{
      this.selectAll = true;
    }
  }

  onYesClick(): void {
    
    this.dialogRef.close();
  }

  FileUploadDone(_evnt){
    this.userLogged =  this._dataService.userId;
      if(_evnt.status == "OK"){
        let _data:any = _evnt.data;
        let newSno:number = this.filesList.length + 1;
         let date: Date = new Date();
              
        this.filesList.push(
          new FileElement(newSno,_data.actFileName,this.userLogged,_data.fileType,_data.filename,date,false)
          );
          this.selectAll = false;
        this.sno++;
      }
  }
  
  ngOnInit() {

    // To Construct the Mail List for "TO" dropdown
    let name = [];
    let eId = [];
    this._dataService.emailGroup.forEach(e => {
      name.push(e.emailGrpName);
      eId.push(e.emailId);
    });
    this._dataService.c30Engineer.forEach(e => {
      name.push(e.c30EngineerName);
      eId.push(e.c30EngineerEmailId);
    });

    this._dataService.superAdmin.forEach(e => {
      name.push(e.superAdminName);
      eId.push(e.emailId);
    });
    for (var i = 0; i < name.length; i++) {
      this.mailList.push({ name: name[i], email: eId[i] });
    }    
  }
   
  onENameChange(_eventMail){    
    this.mailID = _eventMail.value;    
  }
  onEBodyChange(_event) {
    this.mailBody = _event.target.value;
  }
  onCCmailChange(_eventCC) {
    this.mailCC = _eventCC.value;    
  }
  
  onSubChange(_eventSub) {
    this.mailSub = _eventSub.target.value;    
  }
  sendMailC40() {
    this.selectedFileList = [];
    let fileLen = this.filesList.length;
    for (var i = 0; i < fileLen; i++) {
      if (this.filesList[i].isSelected == true) {
        this.selectedFileList.push(this.filesList[i].filename);
      }
    }
   
    let fBodyLen = this.body.length;
    for (let i = 0; i < fBodyLen; i++) {
      this.imgList.push({
        fpath: Object.values(this.body[i])[0],
        fname: Object.values(this.body[i])[1],
        ftype: Object.values(this.body[i])[2]
      });
    }
    
    // Constructing the data for sending to the node for mailrunner
    let mailData = {};
    mailData = { "toMail": this.mailID, "mailBody": this.mailBody, "ccMail":this.mailCC, "subMail":this.mailSub,
    "filenames": this.selectedFileList, "trigger": "", "status": "","imageFile":this.imgList};

    this._dataService.sendaisc40(mailData).subscribe((_docid: any) => {
      if (_docid.status != "OK") {
        this._snackBar.open("Failed to Send Mail", "Dismiss", {
          duration: 6000,
        });   
      }
      else {
        this._snackBar.open("Mail Sent Successfully", "Dismiss", {
          duration: 6000,
        });
        // Reset data
        
        this.bodyModel = '';
        this.toMailModel = '';
        this.ccMailModel = '';
        this.subModel = '';
        this.fileImg = [];
        this.body = [];
        this.imgList=[];
      }
    });

  }


removeFile(_index){
  this.fileImg.splice(_index,1);

  // THIS IS FOR THE REMOVAL OF THE FILE PATH DATA WHICH IS SENT TO THE MAIL BODY
  this.body.splice(_index,1); 

}
onClick() {
  const fileUpload = document.getElementById('fileUploadAttch') as HTMLInputElement;
  fileUpload.onchange = () => {
    for (let index = 0; index < fileUpload.files.length; index++) {
      const file = fileUpload.files[index];
      this.fileImg.push(file);
      this.files.push({
        data: file, state: 'in',
        inProgress: false, progress: 0, canRetry: false, canCancel: true
      });
    }
    this.uploadFiles();
  };
  fileUpload.click();
 
  }


cancelFile(file: FileUploadModel) {
  file.sub.unsubscribe();
  this.removeFileFromArray(file);
}

retryFile(file: FileUploadModel) {
  this.uploadFile(file);
  file.canRetry = false;
}

private uploadFile(file: FileUploadModel) {
  const fd = new FormData(); 
  fd.append(this.param, file.data);
  
  const req = new HttpRequest('POST', this.target, fd, {
    reportProgress: true
  });

  file.inProgress = true;
  file.sub = this._http.request(req).pipe(
    map(event => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          file.progress = Math.round(event.loaded * 100 / event.total);
          break;
        case HttpEventType.Response:
          return event;
      }
    }),
    tap(message => { }),
    last(),
    catchError((error: HttpErrorResponse) => {
      file.inProgress = false;
      file.canRetry = true;
      return of(`${file.data.name} upload failed.`);
    })
  ).subscribe(
    (event:any) => {
      this.body.push(event.body.data);
      if (typeof (event) === 'object') {
        this.removeFileFromArray(file);
        this.complete.emit(event.body);      
      }
    }
  );
}

private uploadFiles() {
  const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
  fileUpload.value = '';
      
  this.files.forEach(file => {
    this.uploadFile(file);
  });
}

private removeFileFromArray(file: FileUploadModel) {
  const index = this.files.indexOf(file);
  if (index > -1) {
    this.files.splice(index, 1);
  }
}


// END
  getDownloadLink(_fObj:FileElement){
    return '/downloadfile?actname='+encodeURIComponent(_fObj.filename)+'&fref=' + _fObj.fileref;
  }
  
 DownloadAll()
{
this.downloadFileIndex = 0;
this.totalDownloadCount = 0;
this.isDownloadMode = true;
this.isDownloadComplete = false;
this.totalDownloadCount = this.textVar.length;
this.zip = new JSZip();
this.startDownload(); 
}   

startDownload(){
  if(this.downloadFileIndex < this.totalDownloadCount){
    let _rtcToken = this.textVar[this.downloadFileIndex];
    
    this._dataService.downloadFileContent(_rtcToken.fileref,_rtcToken.filename)
        .subscribe((_resp:any) => { 
          this.zip.file(_rtcToken.filename, _resp,{binary:true});
          this.downloadFileIndex++;
          setTimeout(() => {
            this.startDownload();  
          }, 1);
        });
  }else{
    this.zip.generateAsync({type:"blob"}).then((content) => {
      // see FileSaver.js
      saveAs(content, "Downloads.zip");
      this.isDownloadMode = false;
      this.isDownloadComplete = true;
      // this.textVar = [];
      // this.checks = false;
      // this.selectAll = false;
    });
  }
}

  removeThisFile(_index){
    this.filesList.splice(_index,1);
    // this.filesList.splice(this.filesList.indexOf(_index),1);
  }
}

export class FileUploadModel {
  data: File;
  state: string;
  inProgress: boolean;
  progress: number;
  canRetry: boolean;
  canCancel: boolean;
  sub?: Subscription;
 
}
